import { db } from "@/firebaseConfig";

const menusCollection = db.collection("menus");

const saveMenu = async (id, data) => {
  menusCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("Menu successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateMenu = async (id, data) => {
  menusCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Menu successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteMenu = async id => {
  menusCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Menu successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getMenuById = async id => {
  return menusCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export { menusCollection, saveMenu, updateMenu, deleteMenu, getMenuById };
